import { QueryClient } from '@tanstack/react-query';
export var queryClient = function (_a) {
    var snackBar = _a.snackBar;
    return new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false,
                refetchOnReconnect: false
            },
            mutations: {
                onError: function (error) {
                    var _a, _b;
                    var message = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || 'Something went wrong';
                    snackBar.error(message);
                }
            }
        }
    });
};
// Primary color config object
export var primaryColorConfig = [
    {
        name: 'primary-1',
        light: '#A379FF',
        main: '#FF0084',
        dark: '#E7177B'
    }
];
export var themeConfig = {
    templateName: 'Webpack',
    settingsCookieName: 'react-base-webpack',
    mode: 'light', // 'light', 'dark'
    layoutPadding: 24, // Common padding for header, content, footer layout components (in px)
    compactContentWidth: 1440, // in px
    disableRipple: false // true, false
};
